import client from './client';

/**
 * Fetch the SpudMarket storefront and the current user's SpudCoin balance.
 * @returns {Promise<{spudcoin_balance:number,items:Array}>}
 */
export const getMarket = async () => {
    const response = await client.get('/market');
    return response.data;
};

/**
 * Buy a market item with SpudCoin.
 * @param {string} itemId
 * @returns {Promise<{message:string,item_id:string,spudcoin_spent:number,spudcoin_balance:number}>}
 */
export const purchaseMarketItem = async (itemId) => {
    const response = await client.post('/market/purchase', { item_id: itemId });
    return response.data;
};
